import React from 'react';
import styled from 'styled-components';

import { mediaQueries } from '../shared/config'




const Text = styled.div`
    font-family: 'Life Savers';
    color: white;
    font-size: 20px;
    text-align: center;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 5%;
    padding-bottom: 5%;

    ${mediaQueries.mobile} {
        margin-right: 1%;
        font-size: 12px;
        padding-bottom: 10px;
  }
`


export default function Description(props)
{
    const Container = styled.div`
    display: block;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #C6815A;
    padding-bottom: 0px;
    img {
        width: 100%;
        padding-bottom: 0px;
    }
`
    return (
        <Container >
            
            <Text>
                {`${props.description_text}`}
            </Text>
        </Container>
    )
}
